// This class should be used on scenarios where VC can not be calculate
// such as: SSR environment and legacy browsers
export class VCObserverNOOP {
  start(startArg) {}
  stop() {}
  getVCRawData() {
    return null;
  }
  getVCResult(param) {
    return Promise.resolve({
      'ufo:vc:noop': true
    });
  }
  setSSRElement(element) {}
  setReactRootRenderStart(startTime) {}
  setReactRootRenderStop(stopTime) {}
}